import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { Formik } from 'formik';
import styled from "styled-components";
import { withRouter } from "react-router";
import { withStyles } from "@material-ui/core/styles";
import { cloneDeep, filter, find, get, isEmpty } from 'lodash';
import { Grid } from "@material-ui/core";
import { ButtonIcon, LOAN_SENIORITY_TYPES, DEAL_STATUSES, DEAL_STAGES, LOAN_STATUSES, ButtonSizeOptions, SecondaryButton, MaterialIcon, GUEST_PERMISSIONS } from '@loanbossinc/component-library';
import { CardPageLayoutNoBanner as CardPageLayout } from "component-lib/CardPageLayoutNoBanner";
import {
  quoteDetailGetQuote, quoteDetailClearQuote, dealGet, getLoansByPreferenceAndLoanSeniority, saveOrderChange, updateLoanDetails, saveQuoteShortListAndStatus, requestNewContact, deleteQuote, cloneQuote
  , loanGetNotes, loanPutNote, loanPostNote, loanDeleteNote
  , loanGetAttachments, loanPutAttachment, loanPostAttachment, loanDeleteAttachment
} from './quoteDetail.store';
import { getLoansByPreferenceAndLoanStatus } from "../../store/state/loan/loan";
import { mapCompanySelector, mapGuestPermissions } from "store/state/auth";
import CompareLoansModal from '../../modals/CompareLoansModal';
import RefiCompareLoansModal from '../../modals/RefiCompareLoansModal';
import QuoteCombineCompareAnalysisModal from '../../modals/QuoteCombineCompareAnalysisModal';
import CombineQuotesModal from '../../modals/CombineQuotes/CombineQuotesModal';
import DynamicQuoteGrid from '../../modules/dynamicQuoteGrid/DynamicQuoteGrid';
import RequestNewContactModal from '../../modals/RequestNewContactModal/RequestNewContactModal';
import PickAWinnerModal from '../../modals/ChangeDealStatusModal/PickAWinnerModal';
import { SimpleInfoModal } from '../../modals/SimpleInfoModal';
import {
  getSectionType, getLoanData, formatForCompare, getSectionLoanData,
  setAmortizationNull, setCashManagementNull, setExtensionsNull, setFeesNull, setFinancialCovenantsNull, setFinancialsNull,
  setGuarantyTypeNull, setInterestRateProtectionNull, setOtherNull, setPrepaymentNull, setReserveAccountsNull,
  shouldShowInterestRate, shouldShowLoanSpread, getFixedFloating
} from './quoteDetail.util';
import {
  StyledCompanyNameContaner, StyledSubmittedByContaner, StyledLabeledButtonMultiple, StyledLeftContainer, StyledLeftChildContainer,
  Frame, StyledButtonText, StyledQuoteGrid, EmptyWrapper, ImageContainer, NoQuotesTextWrapper, ButtonIconContainer, emptyNote,
  QUOTE_PANEL, TERM_SHEET_PANEL, COMPARE_LOANS_MODAL, ANALYSIS_MODAL, COMBINE_LOANS_MODAL, REQUEST_NEW_CONTACT_MODAL, SIMPLE_INFO_MODAL,
  PICK_A_WINNER_MODAL
} from './quoteDetails.styles';
import { defaultColumns, lenderPassedColumns, slColumns } from './gridColumns';
import CenteredTabs from './centeredTabs';
import DetailsTabContent from './detailsTabContent';
import NotesComponent from './NotesComponent';
import AttachmentsComponent from './AttachmentsComponent';
import LenderPassedTabContent from './lenderPassedTabContent';
import FinancialsSection from './termSheetModules/financials/sectionDetails';
import AmortizationSection from './termSheetModules/amortization/sectionDetails';
import PrepaymentSection from './termSheetModules/prepayment/sectionDetails';
import ExtensionsSection from './termSheetModules/extensions/sectionDetails';
import FinancialCovenantsSection from './termSheetModules/financialCovenants/sectionDetails';
import ReserveAccountsSection from './termSheetModules/reserveAccounts/sectionDetails';
import CashManagementSection from './termSheetModules/cashManagement/sectionDetails';
import FeesSection from './termSheetModules/fees/sectionDetails';
import GuarantyTypeSection from './termSheetModules/guarantyType/sectionDetails';
import OtherSection from './termSheetModules/other/sectionDetails';
import InterestRateProtectionSection from './termSheetModules/interestRateProtection/sectionDetails';
import { modifyValuesForSerialization } from "../loanDetail/loanDetailEditUtil";
import { LOAN_SECTION_KEYS } from "../loanDetail/loan.constants";
import { ToastInfo } from "../../components/Global/Toasts/Toasty";

const styles = theme => ({
  drawerPaper: {
    background: '#f5f5f5',
    zIndex: 300,
    width: '576px'
  },
})

const StyledTermSheetButon = styled.div`&& {
  background: #F5F3F3;
  border: 1px solid ${props => props.isDisabled ? "#b1b1b1;" : "#005AA9"};
  box-sizing: border-box;
  border-radius: 8px;
  height: 72px;
  width: 528px;
  margin: auto;
  font-family: Work Sans;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: ${props => props.isDisabled ? "#b1b1b1;" : "#005AA9"};
  margin-top: 26px;
  cursor: ${props => props.isDisabled ? "not-allowed;" : "pointer"};
}`;
const StyledTermSheetButtonBlue = styled(StyledTermSheetButon)`&& {
  background: ${props => props.isDisabled ? "#F5F3F3" : "#005AA9"}; 
  color: ${props => props.isDisabled ? "#b1b1b1;" : "#F5F3F3"}; }`;
const StyledTermSheetButtonBlueSM = styled(StyledTermSheetButon)`&& { background: #005AA9; color: #F5F3F3; width: 132px; height: 36px; }`;

const StyledTermSheetButonRedText = styled(StyledTermSheetButon)`&& { color: ${props => props.isDisabled ? "#b1b1b1" : "#C40A0A"}; }`;
const StyledTermSheetButonRedTextNarrow = styled(StyledTermSheetButonRedText)`&& { width: 252px; }`;

const StyledTermSheetButtonBlueText = styled(StyledTermSheetButon)`&& { color: #005AA9; }`;
const StyledTermSheetButtonBlueTextNarrow = styled(StyledTermSheetButtonBlueText)`&& { width: 252px; }`;
const StyledTermSheetButtonBlueTextSM = styled(StyledTermSheetButtonBlueText)`&& { width: 132px; height: 36px; }`;

const StyledButton = styled.div`&& { margin-top: 26px; }`;
const StyledButtonInnerText = styled.span`&& { vertical-align: top; }`;
const StyledButtonCentered = styled(StyledButton)`&& { text-align: center; }`;
const StyledButtonCenteredSM = styled(StyledButton)`&& { text-align: center; margin-top:7px;}`;

const StyledLinkText = styled.div`&& { color: #005AA9; padding-top: 33px; cursor: pointer; }`;

const StyledContactIconContainer = styled.span`&&{ margin-right: 23px; margin-left: 27px; }`;

const StyledScrollableGrid = styled(Grid)`&& { margin: 24px; }`;

const Divider = styled.div`&& {    
  border: 1px solid #DADCE0;
  width: 100%;
  height: 0px;
  margin-top: 30px;
}`;

class QuoteDetail extends Component {
  formik = React.createRef();
  state = {
    openModal: { name: null },
    isTermSheetOpen: false,
    compareGrid: "",
    scratchContact: {
      firstName: "",
      lastName: "",
      company: "",
      email: "",
      phoneNumber: "",
      address1: "",
      address2: "",
      city: "",
      zip: "",
    },
    confirmationModal: {
      title: "",
      onClose: () => { },
      onAccept: () => { },
      content: "",
    }
  }

  componentDidMount() {
    document.getElementById("ScrollToNav").scrollIntoView({ behavior: "smooth" });
    const { dealId, quoteId } = this.props.match.params;
    !quoteId || quoteId === "new" ? this.props.quoteDetailClearQuote({ dealId }) : this.props.quoteDetailGetQuote({ quoteId });
    this.props.dealGet({ dealId });
    window.addEventListener('resize', this.handleResize);
    this.getQuotes();

    if (quoteId) {
      this.props.loanGetNotes({ quoteId });
      this.props.loanGetAttachments({ modelName: 'loan', modelId: quoteId });
      this.props.getLoansByPreferenceAndLoanStatus({
        dealId,
        loanStatusId: LOAN_STATUSES.CLOSED_LOAN,
        page: 0,
        pageSize: Number.MAX_VALUE,
        includePassedRejected: false,
        subKey: "closedLoans"
      });
    }

  }

  componentDidUpdate(prevProps) {
    const { dealId, quoteId } = this.props.match.params;
    const currentQuoteEmpty = isEmpty(this.props.quote);
    const quotePanelOpen = this.isModalOpen(QUOTE_PANEL);
    if (!quoteId && !quotePanelOpen && !this.state.openModal.name)
      this.openCloseQuotePanel();

    if ((!quoteId || quoteId === "new") && ((!currentQuoteEmpty && this.props.quote.details.id !== null))) // || currentQuoteEmpty
      this.props.quoteDetailClearQuote({ dealId });
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  getQuotes = () => {
    this.getSeniorQuotes(0, 10, "ASC");
    this.getMezzQuotes(0, 10, "ASC");
    this.getSupplementalQuotes(0, 10, "ASC");
    this.getSubsidyQuotes(0, 10, "ASC");
    this.getRejectedQuotes(0, 10, 'ASC');
    this.getPassedQuotes(0, 10, 'ASC');
  }

  getSeniorQuotes = (page, pageSize, sortOrder) => {
    const curriedQuery = this.getLoansBySeniority(null, "senior_quote", LOAN_SENIORITY_TYPES.SENIOR, false);
    curriedQuery(page, pageSize, sortOrder);
  };

  getMezzQuotes = (page, pageSize, sortOrder) => {
    const curriedQuery = this.getLoansBySeniority(null, "mezz_quote", LOAN_SENIORITY_TYPES.SUBORDINATE, false);
    curriedQuery(page, pageSize, sortOrder);
  };

  getSupplementalQuotes = (page, pageSize, sortOrder) => {
    const curriedQuery = this.getLoansBySeniority(null, "supplemental_quote", LOAN_SENIORITY_TYPES.SUPPLEMENTAL, false);
    curriedQuery(page, pageSize, sortOrder);
  }

  getSubsidyQuotes = (page, pageSize, sortOrder) => {
    const curriedQuery = this.getLoansBySeniority(null, "subsidy_quote", LOAN_SENIORITY_TYPES.SUBSIDY, false);
    curriedQuery(page, pageSize, sortOrder);
  }

  getRejectedQuotes = (page, pageSize, sortOrder) => {
    const curriedQuery = this.getLoansBySeniority(null, "rejected_quote", null, LOAN_STATUSES.REJECTED_QUOTE);
    curriedQuery(page, pageSize, sortOrder);
  }

  getPassedQuotes = (page, pageSize, sortOrder) => {
    const curriedQuery = this.getLoansBySeniority(null, "passed_quote", null, LOAN_STATUSES.PASSED_QUOTE);
    curriedQuery(page, pageSize, sortOrder);
  }

  getLoansBySeniority = (desiredColumns, subKey, loanSeniorityId, loanStatus) => {
    const { dealId } = this.props.match.params;
    return (page, pageSize, sortOrder) => {
      this.props.getLoansByPreferenceAndLoanSeniority({
        subKey,
        dealId,
        loanSeniorityId,
        columns: desiredColumns,
        page,
        pageSize,
        sortOrder,
        includePassedRejected: this.props.authentication.isGuest && this.props.guestPermissions && !this.props.guestPermissions.pipelineAllowQuoteStatus,
        isRaw: true,
        loanStatus: loanStatus
      });
    };
  };

  handleResize = (e) => {
    this.setState({ windowWidth: window.innerWidth });
  }

  sidePanelSize = () => {
    const quotePanelOpen = this.isModalOpen(QUOTE_PANEL);
    const termSheetOpen = this.isModalOpen(TERM_SHEET_PANEL);
    const smallScreen = window.innerWidth < 1865;

    if (!quotePanelOpen && !termSheetOpen)
      return smallScreen ? "-1150px" : "-575px";
    if (quotePanelOpen)
      return "-575px";
    else if (termSheetOpen)
      return "0";
  }

  closeModal = () => this.setState({ openModal: { name: null } });
  openModal = (name) => this.setState({ openModal: { name } });
  isModalOpen = (modalName) => {
    const { openModal } = this.state;
    return openModal.name === modalName;
  }

  buildSecondaryButton = (label, onClick, style) => {
    return (<SecondaryButton
      label={label}
      size={ButtonSizeOptions.lgFluid}
      onClick={() => onClick()}
      style={style}
    />)
  }

  openPickAWinnerModal = () => this.openModal(PICK_A_WINNER_MODAL);

  getQuoteDetailButtons = (selectedQuote, handleChange, canEdit) => {
    const { authentication } = this.props;
    const buttonList = [];
    const shortListButton = {
      label: 'Short List',
      onClick: () => {
        if (canEdit && selectedQuote.details.loanStatusId !== LOAN_STATUSES.PASSED_QUOTE && selectedQuote.details.loanStatusId !== LOAN_STATUSES.REJECTED_QUOTE) {
          selectedQuote.details.isShortList = !selectedQuote.details.isShortList;
          handleChange({ shortList: selectedQuote.details.isShortList });
        }
      },
      iconName: "playlist_add",
      selected: selectedQuote.details && selectedQuote.details.isShortList,
      style: selectedQuote.details && selectedQuote.details.isShortList ? { "background-color": "#4FDF77" } : {},
      disabled: !canEdit
    };

    const rejectButton = {
      label: 'Reject',
      onClick: () => {
        if (canEdit) {
          selectedQuote.details.loanStatusId = (selectedQuote.details.loanStatusId === LOAN_STATUSES.REJECTED_QUOTE) ? LOAN_STATUSES.QUOTE : LOAN_STATUSES.REJECTED_QUOTE;
          handleChange({ loanStatusId: selectedQuote.details.loanStatusId });
          this.getRejectedQuotes(0, 10, 'ASC');
        }
      },
      iconName: "thumb_down_off_alt",
      selected: selectedQuote.details && selectedQuote.details.loanStatusId === LOAN_STATUSES.REJECTED_QUOTE,
      style: selectedQuote.details && selectedQuote.details.loanStatusId === LOAN_STATUSES.REJECTED_QUOTE ? { "background-color": "#C40A0A" } : {},
      disabled: !canEdit
    };

    const passedButton = {
      label: 'Lender Passed',
      onClick: () => {
        if (canEdit) {
          selectedQuote.details.loanStatusId = (selectedQuote.details.loanStatusId === LOAN_STATUSES.PASSED_QUOTE) ? LOAN_STATUSES.QUOTE : LOAN_STATUSES.PASSED_QUOTE;
          handleChange({ loanStatusId: selectedQuote.details.loanStatusId });
          this.getPassedQuotes(0, 10, 'ASC');
        }
      },
      iconName: "block",
      selected: selectedQuote.details && selectedQuote.details.loanStatusId === LOAN_STATUSES.PASSED_QUOTE,
      style: selectedQuote.details && selectedQuote.details.loanStatusId === LOAN_STATUSES.PASSED_QUOTE ? { "background-color": "#C40A0A" } : {},
      disabled: !canEdit
    };

    if (!authentication.isGuest)
      buttonList.push(shortListButton);

    buttonList.push(rejectButton);
    buttonList.push(passedButton);

    return buttonList;
  }

  updateQuoteStatus = (item) => {

    const { dealId } = this.props.match.params;
    const { quote } = this.props;
    if (!item || !quote || !quote.details) return null;
    if (item.loanStatusId) quote.details.loanStatusId = item.loanStatusId;
    if (item.shortList !== null) quote.details.isShortList = item.shortList;
    if (item.hasTermSheet !== null) quote.details.hasTermSheet = item.hasTermSheet;

    const payload = {
      dealId,
      id: quote.details.id,
      loanStatusId: quote.details.loanStatusId,
      isShortList: quote.details.isShortList,
      hasTermSheet: quote.details.hasTermSheet,
      callback: this.getQuotes
    }

    this.props.saveQuoteShortListAndStatus(payload)
  }

  isQuoteDetailsValid = (values) => {
    if (!values || !values.details) return false;
    const defaultIndex = getFixedFloating(values);

    //only required fields will be lender, loan type, term, rate type, index, spread/rate
    //revised from story Quote Details Change Orders #r38pkh
    const isEnabled = !isEmpty(values)
      && !isEmpty(values.details)
      && !!get(values, "details.loanProvider[0].loanCompanyBridge.companyId")
      && !!values.details.loanTypeId
      && !!values.details.loanTermMonths
      && !!values.details.rateTypeId
      && !!values.details.indexId
      && (
        (shouldShowInterestRate(defaultIndex, values) && !!values.details.interestRate)
        ||
        (shouldShowLoanSpread(values) && !!values.details.loanSpread)
      );
    return isEnabled;
  }

  openCloseTermSheetPanel = (close, quote) => {
    if (this.isQuoteDetailsValid(quote)) {
      if (this.isModalOpen(TERM_SHEET_PANEL) || close) {
        this.closeModal()
        this.openModal(QUOTE_PANEL)
        this.setState({ isTermSheetOpen: false });
      } else {
        this.openModal(TERM_SHEET_PANEL);
        this.setState({ isTermSheetOpen: true });
      }
    }
  };

  openCloseQuotePanel = () => {
    this.isModalOpen(QUOTE_PANEL) ? this.closeModal() : this.openModal(QUOTE_PANEL);
  };

  openNewQuoteQuotePanel = () => {
    this.props.history.replace(`/quotes/${this.props.deal.id}/new`);
    this.openModal(QUOTE_PANEL);
  };

  openAnalysisModal = () => {
    this.isModalOpen(ANALYSIS_MODAL) ? this.closeModal() : this.openModal(ANALYSIS_MODAL);
    //Need to clear out the selected quote
  };

  emptyContainer = () => {
    return <>
      <EmptyWrapper>
        <ImageContainer>
          <img src={emptyNote} />
        </ImageContainer>
      </EmptyWrapper>
      <br />
      <NoQuotesTextWrapper>Get started by creating a quote for this deal</NoQuotesTextWrapper>
    </>
  };

  hasSeniorAndMezzLoans = () => {
    return this.props.seniorLoanCount > 0 && this.props.mezzLoanCount > 0;
  };

  showCombine = isCompareAndCombine => {
    this.openModal(COMBINE_LOANS_MODAL);
    this.setState({
      isCompareAndCombine: !!isCompareAndCombine
    });
  };

  updateScratchContact = (fieldName, value) => {
    if (fieldName === "Clear") {
      this.setState({
        scratchContact: {
          firstName: "",
          lastName: "",
          company: "",
          email: "",
          phoneNumber: "",
          address1: "",
          address2: "",
          city: "",
          zip: "",
        }
      });
    } else {
      if (value === "") value = null;
      let contact = this.state.scratchContact;
      contact[fieldName] = value;
      this.setState({ scratchContact: contact });
    }
  }

  clearTermSheetFields = (handleReset) => {
    const { quoteId } = this.props.match.params;
    const { quote } = this.props;
    quote.details.hasTermSheet = false;
    setAmortizationNull(quote);
    setCashManagementNull(quote);
    setExtensionsNull(quote);
    setFeesNull(quote);
    setFinancialCovenantsNull(quote);
    setFinancialsNull(quote);
    setGuarantyTypeNull(quote);
    setInterestRateProtectionNull(quote);
    setOtherNull(quote);
    setPrepaymentNull(quote);
    setReserveAccountsNull(quote);
    quote.hasTermSheet = false;
    handleReset();
    this.onSubmit(quote, () => this.props.quoteDetailGetQuote({ quoteId }));
    this.openCloseTermSheetPanel(true, quote);
  }

  renderModals = () => {
    const { deal, authentication } = this.props;
    const isDead = deal && deal.dealStatus && deal.dealStatus.id === DEAL_STATUSES.DEAD;
    let inClosing = !authentication.isGuest && deal.stageId === DEAL_STAGES.IN_CLOSING;
    const isRefinance = deal && deal.dealStatus && deal.dealStatus.id === DEAL_STATUSES.REFINANCE;
    const isAddingSupplemental = deal && deal.dealStatus && deal.dealStatus.id === DEAL_STATUSES.ADDING_SUPPLEMENTAL;
    const isPipeline = deal && deal.dealStatus && deal.dealStatus.id === DEAL_STATUSES.PIPELINE;
    const isModifying = deal && deal.dealStatus && deal.dealStatus.id === DEAL_STATUSES.MODIFYING;

    return (<>
      {this.state.compareGrid !== "" && <CompareLoansModal
        dealId={deal.id}
        onClose={() => this.closeModal()}
        quoteType={getSectionType(this.state.compareGrid)}
        loans={getSectionLoanData(this.props, this.state.compareGrid)}
        isOpen={this.isModalOpen(COMPARE_LOANS_MODAL) && !isRefinance}
        isModifying={isModifying}
        maxCount={isModifying ? 1 : 4}
      />}
      <RefiCompareLoansModal
        dealId={deal.id}
        onClose={() => this.closeModal()}
        quoteType={getSectionType(this.state.compareGrid)}
        loans={getSectionLoanData(this.props, this.state.compareGrid)}
        isOpen={this.isModalOpen(COMPARE_LOANS_MODAL) && isRefinance}
        history={this.props.history}
        maxCount={4}
      />
      <QuoteCombineCompareAnalysisModal
        isRefi={isRefinance}
        isModifyDeal={isModifying}
        hasSeniorAndMezzLoans={this.hasSeniorAndMezzLoans()}
        dealId={deal.id}
        isOpen={this.isModalOpen(ANALYSIS_MODAL)}
        handleClose={() => this.closeModal()}
        selectCombine={() => {
          this.closeModal();
          this.showCombine();
        }}
        selectCompareAndCombine={() => {
          this.closeModal();
          this.showCombine(true);
        }}
        selectCompare={() => {
          this.closeModal();
          this.openModal(COMPARE_LOANS_MODAL)
        }}
      />
      <CombineQuotesModal
        dealId={deal.id}
        onClose={() => this.closeModal()}
        seniorLoans={getLoanData(this.props, "senior_quote").map(formatForCompare)}
        mezzLoans={getLoanData(this.props, "mezz_quote").map(formatForCompare)}
        isOpen={this.isModalOpen(COMBINE_LOANS_MODAL)}
        isCompareAndCombine={this.state.isCompareAndCombine}
      />
      <RequestNewContactModal
        scratchContact={this.state.scratchContact}
        updateScratchContact={this.updateScratchContact}
        modalOpen={this.isModalOpen(REQUEST_NEW_CONTACT_MODAL)}
        handleClose={() => this.closeModal()}
        handleAccept={this.sendContactRequest}
        users={{ error: false }} />

      <SimpleInfoModal
        title={this.state.confirmationModal.title}
        isOpen={this.isModalOpen(SIMPLE_INFO_MODAL)}
        onClose={() => this.state.confirmationModal.onClose()}
        onAccept={() => this.state.confirmationModal.onAccept()}
        content={this.state.confirmationModal.content}
      />

      <PickAWinnerModal
        dealId={deal.id}
        onClose={() => this.closeModal()}
        seniorLoans={getLoanData(this.props, "senior_quote").map(formatForCompare)}
        mezzLoans={getLoanData(this.props, "mezz_quote").map(formatForCompare)}
        supplementalLoans={getLoanData(this.props, "supplemental_quote").map(formatForCompare)}
        supplementalLoansOnly={isAddingSupplemental}
        refreshGridCallback={this.getQuotes}
        isOpen={this.isModalOpen(PICK_A_WINNER_MODAL)}
      />
    </>);
  };



  openConfirmationDialog = (title, onClose, onAccept, content) => {
    this.setState({ confirmationModal: { title, onClose, onAccept, content } });
    this.openModal(SIMPLE_INFO_MODAL);
  }

  findSelectedQuote = () => {
    const { dealId, quoteId } = this.props.match.params;
    const { deal, quotesByPreference } = this.props;
    if (!quotesByPreference) return null;
    if (quoteId) {
      const senior_quote = quotesByPreference.senior_quote ? quotesByPreference.senior_quote.data.loans : [];
      const mezz_quote = quotesByPreference.mezz_quote ? quotesByPreference.mezz_quote.data.loans : [];
      const supplemental_quote = quotesByPreference.supplemental_quote ? quotesByPreference.supplemental_quote.data.loans : [];
      const rejected_quote = quotesByPreference.rejected_quote ? quotesByPreference.rejected_quote.data.loans : [];
      const passed_quote = quotesByPreference.passed_quote ? quotesByPreference.passed_quote.data.loans : [];
      var allQuotes = [].concat(senior_quote, mezz_quote, supplemental_quote, rejected_quote, passed_quote);
      return find(allQuotes, function (o) { return o.id == quoteId; });
    }

    return {}
  }

  filterShortListQuotes = (data, includeShortList) => {
    const { authentication } = this.props;
    if (!data) return [];
    const filtered = authentication.isGuest ? data.loans : filter(data.loans, (o) => includeShortList ? o.isShortList : !o.isShortList);
    return filtered.sort((a, b) => a.shortListSortOrder - b.shortListSortOrder);
  }

  sendContactRequest = (contact) => {
    this.props.requestNewContact({ contact, sender: this.props.authentication.user });
    this.closeModal();
  }

  rowClick = (item) => {
    const { dealId, quoteId } = this.props.match.params;
    this.props.history.replace(`/quotes/${dealId}/${item.id}`);
    this.props.quoteDetailGetQuote({ quoteId: item.id });
    this.props.loanGetNotes({ quoteId: item.id });
    this.props.loanGetAttachments({ modelName: 'loan', modelId: item.id });
    this.openModal(QUOTE_PANEL);
  }

  ////////////////////////////////////////////////
  renderLeft = () => {
    const { deal, quotesByPreference, authentication, guestPermission } = this.props;
    if (!deal || !quotesByPreference) return null;
    const smallScreen = window.innerWidth < 1865;
    const noQuotes = (!quotesByPreference ||
      (
        quotesByPreference &&
        quotesByPreference.senior_quote && quotesByPreference.senior_quote.data.loans.length === 0 &&
        quotesByPreference.mezz_quote && quotesByPreference.mezz_quote.data.loans.length === 0 &&
        quotesByPreference.supplemental_quote && quotesByPreference.supplemental_quote.data.loans.length === 0 &&
        quotesByPreference.rejected_quote && quotesByPreference.rejected_quote.data.loans.length === 0 &&
        quotesByPreference.passed_quote && quotesByPreference.passed_quote.data.loans.length === 0
      )
    )
    let selectedQuote;
    let srList = [];
    let srShortList = [];
    let subList = [];
    let subShortList = [];
    let suppList = [];
    let suppShortList = [];
    let rejectedList = [];
    let passedList = [];

    selectedQuote = this.findSelectedQuote();

    if (quotesByPreference.senior_quote) {
      srList = this.filterShortListQuotes(quotesByPreference.senior_quote.data || [], false)
      srShortList = this.filterShortListQuotes(quotesByPreference.senior_quote.data || [], true)
    }

    if (quotesByPreference.mezz_quote) {
      subList = this.filterShortListQuotes(quotesByPreference.mezz_quote.data || [], false)
      subShortList = this.filterShortListQuotes(quotesByPreference.mezz_quote.data || [], true)
    }

    if (quotesByPreference.supplemental_quote) {
      suppList = this.filterShortListQuotes(quotesByPreference.supplemental_quote.data || [], false)
      suppShortList = this.filterShortListQuotes(quotesByPreference.supplemental_quote.data || [], true)
    }
    if (quotesByPreference.rejected_quote) {
      rejectedList = this.filterShortListQuotes(quotesByPreference.rejected_quote.data || [], false)
    }
    if (quotesByPreference.passed_quote) {
      passedList = this.filterShortListQuotes(quotesByPreference.passed_quote.data || [], false)
    }

    const isAddingSupplemental = deal && deal.dealStatusId === DEAL_STATUSES.ADDING_SUPPLEMENTAL;

    const canViewRejectedPassed = !authentication.isGuest || (authentication.isGuest && guestPermission.pipelineAllowQuoteStatus);
    const canEdit = !authentication.isGuest || (authentication.isGuest && guestPermission && guestPermission.pipelinePermissionId && guestPermission.pipelinePermissionId === GUEST_PERMISSIONS.EDIT);
    const canCombineCompare = !authentication.isGuest || (authentication.isGuest && guestPermission && (guestPermission.portfolioProjections || guestPermission.pipelineProjections));

    return (<>
      <StyledLeftContainer>
        <StyledLeftChildContainer>
          <StyledButtonText
            label={deal.name}
            iconName={"arrow_forward"}
            reverse={true}
            alignRight={false}
            key={1}
            onClick={() => this.props.history.goBack()} />
        </StyledLeftChildContainer>

        {!noQuotes && <StyledLeftChildContainer>
          {canEdit && this.buildSecondaryButton("Create Quote", this.openNewQuoteQuotePanel, {})}
          {canCombineCompare && this.buildSecondaryButton("Combine Quotes", this.showCombine, { marginLeft: "14px" })}
          {smallScreen && this.buildSecondaryButton("Open Quote Panel", () => this.openModal(QUOTE_PANEL), { marginLeft: "14px" })}
        </StyledLeftChildContainer>}

        {!isAddingSupplemental && (srShortList || srList) && (srShortList.length > 0 || srList.length > 0) &&
          <DynamicQuoteGrid
            iconName={"description"}
            quoteStatus={"Senior Quotes"}
            selectedQuote={selectedQuote}
            compareQuotes={() => { this.openModal(COMPARE_LOANS_MODAL); this.setState({ compareGrid: "senior_quote" }) }}
            shortList={srShortList}
            quotes={srList}
            history={this.props.history}
            deal={deal}
            saveOrderChange={(items) => this.props.saveOrderChange({ ...items, callback: () => this.getSeniorQuotes(0, 10, "ASC") })}
            noDataMessage={"No active quotes"}
            noSLDataMessage={"Shortlist quotes to see and rank them above other quotes"}
            columns={defaultColumns}
            slColumns={slColumns}
            onRowClick={this.rowClick}
            canCombineCompare={canCombineCompare}
            hideShortList={authentication.isGuest}
          />}

        {!isAddingSupplemental && (subShortList || subList) && (subShortList.length > 0 || subList.length > 0) &&
          <DynamicQuoteGrid
            iconName={"description"}
            quoteStatus={"Subordinate Quotes"}
            selectedQuote={selectedQuote}
            compareQuotes={() => { this.openModal(COMPARE_LOANS_MODAL); this.setState({ compareGrid: "mezz_quote" }) }}
            shortList={subShortList}
            quotes={subList}
            history={this.props.history}
            deal={deal}
            saveOrderChange={(items) => this.props.saveOrderChange({ ...items, callback: () => this.getMezzQuotes(0, 10, "ASC") })}
            noDataMessage={"No active quotes"}
            noSLDataMessage={"Shortlist quotes to see and rank them above other quotes"}
            columns={defaultColumns}
            slColumns={slColumns}
            onRowClick={this.rowClick}
            canCombineCompare={canCombineCompare}
            hideShortList={authentication.isGuest}
          />}

        {isAddingSupplemental && (suppList || suppShortList) && (suppList.length > 0 || suppShortList.length > 0) &&
          <DynamicQuoteGrid
            iconName={"description"}
            quoteStatus={"Supplemental Quotes"}
            selectedQuote={selectedQuote}
            compareQuotes={() => { this.openModal(COMPARE_LOANS_MODAL); this.setState({ compareGrid: "supplemental_quote" }) }}
            shortList={suppShortList}
            quotes={suppList}
            history={this.props.history}
            deal={deal}
            saveOrderChange={(items) => this.props.saveOrderChange({ ...items, callback: () => this.getSupplementalQuotes(0, 10, "ASC") })}
            noDataMessage={"No active quotes"}
            noSLDataMessage={"Shortlist quotes to see and rank them above other quotes"}
            columns={defaultColumns}
            slColumns={slColumns}
            onRowClick={this.rowClick}
            canCombineCompare={canCombineCompare}
            hideShortList={authentication.isGuest}
          />}

        {rejectedList && rejectedList.length > 0 && canViewRejectedPassed &&
          <DynamicQuoteGrid
            iconName={"thumb_down"}
            quoteStatus={"Rejected Quotes"}
            selectedQuote={selectedQuote}
            quotes={rejectedList}
            history={this.props.history}
            deal={deal}
            noDataMessage={"Disqualify a quote by rejecting it to see it here."}
            hideShortList
            columns={defaultColumns}
            onRowClick={this.rowClick}
          />}

        {passedList && passedList.length > 0 && canViewRejectedPassed &&
          <DynamicQuoteGrid
            iconName={"not_interested"}
            quoteStatus={"Lender Passed"}
            selectedQuote={selectedQuote}
            quotes={passedList}
            history={this.props.history}
            deal={deal}
            noDataMessage={"Disqualify a quote by marking it as ‘Lender Passed’ to see it here."}
            hideShortList
            columns={lenderPassedColumns}
            onRowClick={this.rowClick}
          />}
        {noQuotes && window.innerWidth < 1865 && <StyledLeftChildContainer>
          {this.buildSecondaryButton("Create Quote", this.openNewQuoteQuotePanel, {})}
        </StyledLeftChildContainer>}
        {noQuotes && <StyledLeftChildContainer>
          <Grid container direction="column" id="notesList" alignItems={'center'}>{this.emptyContainer()}</Grid>
        </StyledLeftChildContainer>}
      </StyledLeftContainer>

      {this.renderModals()}
    </>)
  };

  getRefreshFunction = () => {
    const { quote } = this.props;
    const NotLoaded = "Quote Type not Loaded";
    const ZERO = 0;
    const TEN = 10;
    if (isEmpty(quote) || isEmpty(quote.details) || isEmpty(quote.details.loanStatusId)) {
      const { dealId } = this.props.match.params;
      this.props.quoteDetailClearQuote({ dealId })
      this.getQuotes();
      this.openNewQuoteQuotePanel()
      return true;
    }

    switch (quote.details.loanStatusId) {
      case LOAN_STATUSES.REJECTED_QUOTE:
        this.getRejectedQuotes(ZERO, TEN, "ASC");
        break;

      case LOAN_STATUSES.PASSED_QUOTE:
        this.getPassedQuotes(ZERO, TEN, "ASC");
        break;

      case LOAN_STATUSES.QUOTE:
      case LOAN_STATUSES.CLOSED_LOAN:
      case LOAN_STATUSES.WINNING_QUOTE:
      case LOAN_STATUSES.IN_CLOSING:
        if (isEmpty(quote) || isEmpty(quote.details) || isEmpty(quote.details.loanSeniorityId)) {
          ToastInfo(NotLoaded);
        } else {
          switch (quote.details.loanSeniorityId) {
            case LOAN_SENIORITY_TYPES.SENIOR:
              this.getSeniorQuotes(ZERO, TEN, "ASC");
              break;
            case LOAN_SENIORITY_TYPES.SUBORDINATE:
              this.getMezzQuotes(ZERO, TEN, "ASC");
              break;
            case LOAN_SENIORITY_TYPES.SUPPLEMENTAL:
              this.getSupplementalQuotes(ZERO, TEN, "ASC");
              break;
            case LOAN_SENIORITY_TYPES.SUBSIDY:
              this.getSubsidyQuotes(ZERO, TEN, "ASC");
              break;
            default:
              ToastInfo(NotLoaded);
              break;
          }
        }
        break;

      case LOAN_STATUSES.PAID_OFF:
      case LOAN_STATUSES.MODIFYING:
      case LOAN_STATUSES.MODIFIED:
      default:
        ToastInfo(NotLoaded);
        break;
    }
  }

  onSubmit = (loan, callback) => {
    if (!this.isQuoteDetailsValid(loan)) return;
    const { dealId } = this.props.match.params;
    if (loan) {
      const id = loan.details.id;
      let loanDetailsRequest = {};
      const skipCashflowUpdate = this.shouldskipCashflowUpdate();
      if (!id) {
        loanDetailsRequest = loan;
        loanDetailsRequest.isNew = true;
        loanDetailsRequest.details["dealId"] = dealId;
        loanDetailsRequest.details["loanStatusId"] = LOAN_STATUSES.QUOTE;
        if (this.props.deal.dealStatusId === DEAL_STATUSES.ADDING_SUPPLEMENTAL) {
          if (!loanDetailsRequest.details)
            loanDetailsRequest.details = {};
          loanDetailsRequest.details.loanSeniorityId = LOAN_SENIORITY_TYPES.SUPPLEMENTAL;
        }
        loanDetailsRequest = modifyValuesForSerialization(loan);
        ToastInfo("Saving... Please wait")
        this.props.updateLoanDetails({
          id: 'new', loanDetails: loanDetailsRequest, callback: () => {
            const { quoteId } = this.props;
            if (quoteId) {
              this.props.history.replace(`/quotes/${dealId}/${quoteId}`);
              this.props.quoteDetailGetQuote({ quoteId });
              this.props.loanGetNotes({ quoteId });
              this.props.loanGetAttachments({ modelName: 'loan', modelId: quoteId });
            }
            this.getQuotes();
          }
        });
      } else {
        loanDetailsRequest.id = id;
        loanDetailsRequest.isNew = false;
        const clonedValues = cloneDeep(loan);
        loanDetailsRequest.loanDetails = modifyValuesForSerialization(clonedValues);
        loanDetailsRequest.loanDetails.skipCashflowUpdate = skipCashflowUpdate;
        if (callback && (callback instanceof Function))
          loanDetailsRequest.callback = () => { this.getQuotes(); callback() };
        else
          loanDetailsRequest.callback = this.getQuotes;
        if (this.props.deal.dealStatusId === DEAL_STATUSES.ADDING_SUPPLEMENTAL) {
          if (!loanDetailsRequest.details)
            loanDetailsRequest.details = {};
          loanDetailsRequest.details.loanSeniorityId = LOAN_SENIORITY_TYPES.SUPPLEMENTAL;
        }
        ToastInfo("Saving... Please wait")
        this.props.updateLoanDetails(loanDetailsRequest);
      }
    }
  }

  shouldskipCashflowUpdate = () => {
    const { sectionName } = this.props.match.params;
    switch (sectionName) {
      case LOAN_SECTION_KEYS.FINANCIAL_COVENANTS:
      case LOAN_SECTION_KEYS.DEFINITIONS:
        return true;

      case LOAN_SECTION_KEYS.SECTION_ADDITIONAL_ADVANCES:
      case LOAN_SECTION_KEYS.SECTION_ESCROW_RESERVE:
      case LOAN_SECTION_KEYS.CLOSING_COSTS:
      case LOAN_SECTION_KEYS.CASH_MANAGEMENT:
      case LOAN_SECTION_KEYS.FINANCIAL_CASH_MANAGEMENT:
      case LOAN_SECTION_KEYS.LEASING:
      case LOAN_SECTION_KEYS.GENERAL_INFORMATION:
      case LOAN_SECTION_KEYS.AMORTIZATION:
      case LOAN_SECTION_KEYS.EXTENSIONS:
      case LOAN_SECTION_KEYS.BORROWERDOCS:
      case LOAN_SECTION_KEYS.GUARANTORDOCS:
      case LOAN_SECTION_KEYS.FINANCIALMISCELLANEOUS:
      case LOAN_SECTION_KEYS.GUARANTY:
      case LOAN_SECTION_KEYS.HEDGE_REQUIREMENTS:
      case LOAN_SECTION_KEYS.INSURANCE:
      case LOAN_SECTION_KEYS.MISCELLANEOUS:
      case LOAN_SECTION_KEYS.PARTIAL_RELEASE:
      case LOAN_SECTION_KEYS.PROPERTY_ALLOCATIONS:
      default:
        return false;
    }
  }

  renderRight = () => {
    const { quote } = this.props;
    const smallScreen = window.innerWidth < 1865;
    return <Formik
      enableReinitialize={true}
      ref={this.formik}
      validateOnChange={true}
      handleChange={(item) => console.log("handleChange", item)}
      onSubmit={this.onSubmit}
      initialValues={quote}
      onReset={(initialValues, form) => {
        form.resetForm(initialValues);
      }}
      render={({ values, handleSubmit, handleReset }) => {
        const lenderCompanyName = get(values, 'details.lenderCompany.name');
        const submittedByContact = get(values, 'details.submittedByContact');
        const hasTermSheet = get(values, 'details.hasTermSheet');
        const loanId = get(values, 'details.id');
        const refreshFunction = this.getRefreshFunction;

        const loanStatusId = get(values, 'details.loanStatusId');
        return loanStatusId === LOAN_STATUSES.PASSED_QUOTE ? this.lenderPassedFields(smallScreen,
          quote,
          lenderCompanyName,
          submittedByContact,
          hasTermSheet,
          loanId,
          refreshFunction,
          handleSubmit,
          handleReset) :
          this.defaultFields(values,
            smallScreen,
            quote,
            lenderCompanyName,
            submittedByContact,
            hasTermSheet,
            loanId,
            refreshFunction,
            handleSubmit,
            handleReset);

      }}
    />
  };

  lenderPassedFields(smallScreen, quote, lenderCompanyName, submittedByContact, hasTermSheet, loanId, refreshFunction, handleSubmit, handleReset) {
    const { authentication, guestPermission } = this.props;
    const canViewStatusButtons = !authentication.isGuest || (authentication.isGuest && guestPermission && guestPermission.pipelineAllowQuoteStatus);

    return (<Frame sidePanelSize={this.sidePanelSize}>
      <Grid container>
        <StyledQuoteGrid item xs={6}>
          {smallScreen && <ButtonIconContainer><ButtonIcon hasBorder iconName="close" onClick={() => this.openCloseQuotePanel()} /></ButtonIconContainer>}
          <div>

            {canViewStatusButtons && <StyledLabeledButtonMultiple options={this.getQuoteDetailButtons(quote, this.updateQuoteStatus)} />}

            {!isEmpty(this.props.quote) &&
              <StyledCompanyNameContaner>
                {lenderCompanyName}
              </StyledCompanyNameContaner>}

            {!isEmpty(this.props.quote) && submittedByContact &&
              <StyledSubmittedByContaner>
                Submitted by {submittedByContact.fullName}
              </StyledSubmittedByContaner>}

            <div>
              <CenteredTabs
                DetailsComponent={LenderPassedTabContent}
                openRequestContactModal={() => this.openModal(REQUEST_NEW_CONTACT_MODAL)}
                isTermSheetOpen={this.state.isTermSheetOpen}
                loanId={loanId}
                authentication={this.props.authentication}

                NotesComponent={NotesComponent}
                notes={this.props.notes}
                postNote={this.props.loanPostNote}
                putNote={this.props.loanPutNote}
                deleteNote={this.props.loanDeleteNote}

                AttachmentsComponent={AttachmentsComponent}
                attachments={this.props.attachments}
                isLoading={this.props.isLoading}
                PutAttachment={this.props.loanPutAttachment}
                PostAttachment={this.props.loanPostAttachment}
                DeleteAttachment={this.props.loanDeleteAttachment}
              />
            </div>

            <Grid container>
              <Grid item xs={6}>
                <StyledTermSheetButonRedTextNarrow
                  onClick={() => {
                    this.openConfirmationDialog(
                      "Delete Quote",
                      this.closeModal,
                      () => {
                        if (loanId)
                          this.props.deleteQuote({ quoteId: loanId, callback: refreshFunction });
                        this.closeModal();
                      },
                      (<><p>Are you sure that you want to delete this quote?</p> <p>This action cannot be undone.</p></>)
                    );
                  }}>
                  <StyledButtonCentered>
                    Delete Quote
                  </StyledButtonCentered>
                </StyledTermSheetButonRedTextNarrow>
              </Grid>
              <Grid item xs={6}>
                <StyledTermSheetButtonBlueTextNarrow
                  onClick={() => {
                    this.openConfirmationDialog(
                      "Duplicate Quote",
                      this.closeModal,
                      () => {
                        if (loanId)
                          this.props.cloneQuote({ loanId, loanStatusId: quote.details.loanStatusId, callback: refreshFunction });
                        this.closeModal();
                      },
                      (<><p>Are you sure that you want to duplicate this quote?</p></>)
                    );
                  }}>
                  <StyledButtonCentered>
                    Duplicate Quote
                  </StyledButtonCentered>
                </StyledTermSheetButtonBlueTextNarrow>
              </Grid>
            </Grid>

            <StyledTermSheetButtonBlue onClick={handleSubmit}>
              <StyledButtonCentered>
                Save Quote
              </StyledButtonCentered>
            </StyledTermSheetButtonBlue>
          </div>
        </StyledQuoteGrid>


        <StyledQuoteGrid item xs={6}></StyledQuoteGrid>
      </Grid>
    </Frame>);
  }

  defaultFields(values, smallScreen, quote, lenderCompanyName, submittedByContact, hasTermSheet, loanId, refreshFunction, handleSubmit, handleReset) {

    const { quoteId } = this.props.match.params;
    const { deal, authentication, guestPermission } = this.props;
    const canEdit = !authentication.isGuest || (authentication.isGuest && guestPermission && guestPermission.pipelinePermissionId && guestPermission.pipelinePermissionId === GUEST_PERMISSIONS.EDIT);
    const canViewStatusButtons = !authentication.isGuest || (authentication.isGuest && guestPermission && guestPermission.pipelineAllowQuoteStatus);
    const isButtonDisabled = !this.isQuoteDetailsValid(values);
    const isNew = quoteId === 'new';
    return (<Frame sidePanelSize={this.sidePanelSize}>
      <Grid container>
        <StyledQuoteGrid item xs={6}>
          {smallScreen && <ButtonIconContainer><ButtonIcon hasBorder iconName="close" onClick={() => this.openCloseQuotePanel()} /></ButtonIconContainer>}
          <div>

            {canViewStatusButtons && <StyledLabeledButtonMultiple options={this.getQuoteDetailButtons(quote, this.updateQuoteStatus, canEdit)} />}

            {!isEmpty(this.props.quote) &&
              <StyledCompanyNameContaner>
                {lenderCompanyName}
              </StyledCompanyNameContaner>}

            {!isEmpty(this.props.quote) && submittedByContact &&
              <StyledSubmittedByContaner>
                Submitted by {submittedByContact.fullName}
              </StyledSubmittedByContaner>}

            {this.props.quote && this.props.quote.details && this.props.quote.details.id === null &&
              <StyledCompanyNameContaner>
                Create Quote
              </StyledCompanyNameContaner>}

            <div>
              <CenteredTabs
                DetailsComponent={DetailsTabContent}
                openRequestContactModal={() => this.openModal(REQUEST_NEW_CONTACT_MODAL)}
                isTermSheetOpen={this.state.isTermSheetOpen}
                loanId={loanId}
                deal={deal}
                authentication={this.props.authentication}

                NotesComponent={NotesComponent}
                notes={this.props.notes}
                postNote={this.props.loanPostNote}
                putNote={this.props.loanPutNote}
                deleteNote={this.props.loanDeleteNote}

                AttachmentsComponent={AttachmentsComponent}
                attachments={this.props.attachments}
                isLoading={this.props.isLoading}
                PutAttachment={this.props.loanPutAttachment}
                PostAttachment={this.props.loanPostAttachment}
                DeleteAttachment={this.props.loanDeleteAttachment}
              />
            </div>

            {!this.state.isTermSheetOpen && !hasTermSheet && <div>
              <StyledTermSheetButon isDisabled={isButtonDisabled || isNew} onClick={() => {
                if (isButtonDisabled || isNew)
                  return;
                this.updateQuoteStatus({ hasTermSheet: true });
                values.details.hasTermSheet = true;
                this.openCloseTermSheetPanel(null, values);
              }}>
                <StyledButton>

                  <StyledContactIconContainer>
                    <MaterialIcon iconName={"assignment"} />
                  </StyledContactIconContainer>

                  <StyledButtonInnerText>{`${isNew ? 'Save Quote to add Term Sheet' : 'Build Term Sheet'}`}</StyledButtonInnerText>

                  <StyledContactIconContainer style={{ 'float': 'right' }}>
                    <MaterialIcon iconName={"east"} />
                  </StyledContactIconContainer>

                </StyledButton>
              </StyledTermSheetButon>
            </div>}


            {!this.state.isTermSheetOpen && hasTermSheet && <div>
              <StyledTermSheetButtonBlue
                isDisabled={isButtonDisabled}
                onClick={() => { this.openCloseTermSheetPanel(null, values); }}
              >
                <StyledButton>

                  <StyledContactIconContainer>
                    <MaterialIcon iconName={"assignment"} />
                  </StyledContactIconContainer>

                  <StyledButtonInnerText>Show Term Sheet</StyledButtonInnerText>

                  <StyledContactIconContainer style={{ 'float': 'right' }}>
                    <MaterialIcon iconName={"east"} />
                  </StyledContactIconContainer>

                </StyledButton>
              </StyledTermSheetButtonBlue>
            </div>}


            {this.state.isTermSheetOpen && hasTermSheet && <div>
              <StyledTermSheetButtonBlue isDisabled={isButtonDisabled} onClick={() => { this.openCloseTermSheetPanel(null, values); }}>
                <StyledButton>
                  <StyledContactIconContainer>
                    <MaterialIcon iconName={"assignment"} />
                  </StyledContactIconContainer>

                  <StyledButtonInnerText>Hide Term Sheet</StyledButtonInnerText>

                  <StyledContactIconContainer style={{ 'float': 'right' }}>
                    <MaterialIcon iconName={"west"} />
                  </StyledContactIconContainer>
                </StyledButton>
              </StyledTermSheetButtonBlue>
            </div>}


            {hasTermSheet && canEdit && !isNew && <div>
              <StyledTermSheetButonRedText isDisabled={isButtonDisabled} onClick={() => this.clearTermSheetFields(handleReset)}>
                <StyledButtonCentered>
                  Delete Term Sheet
                </StyledButtonCentered>
              </StyledTermSheetButonRedText>
            </div>}

            {canEdit && !isNew && <Grid container>
              {!authentication.isGuest && <Grid item xs={6}>
                <StyledTermSheetButonRedTextNarrow
                  onClick={() => {
                    this.openConfirmationDialog(
                      "Delete Quote",
                      this.closeModal,
                      () => {
                        if (loanId)
                          this.props.deleteQuote({ quoteId: loanId, callback: refreshFunction });
                        this.closeModal();
                      },
                      (<><p>Are you sure that you want to delete this quote?</p> <p>This action cannot be undone.</p></>)
                    );
                  }}>
                  <StyledButtonCentered>
                    Delete Quote
                  </StyledButtonCentered>
                </StyledTermSheetButonRedTextNarrow>
              </Grid>}
              <Grid item xs={authentication.isGuest ? 12 : 6}>
                <StyledTermSheetButtonBlueTextNarrow
                  onClick={() => {
                    this.openConfirmationDialog(
                      "Duplicate Quote",
                      this.closeModal,
                      () => {
                        if (loanId)
                          this.props.cloneQuote({ loanId, loanStatusId: quote.details.loanStatusId, callback: refreshFunction });
                        this.closeModal();
                      },
                      (<><p>Are you sure that you want to duplicate this quote?</p></>)
                    );
                  }}>
                  <StyledButtonCentered>
                    Duplicate Quote
                  </StyledButtonCentered>
                </StyledTermSheetButtonBlueTextNarrow>
              </Grid>
            </Grid>}

            {canEdit &&
              <StyledTermSheetButtonBlue isDisabled={isButtonDisabled} onClick={handleSubmit}>
                <StyledButtonCentered>
                  Save Quote
                </StyledButtonCentered>
              </StyledTermSheetButtonBlue>}
          </div>
        </StyledQuoteGrid>


        <StyledQuoteGrid container item xs={6}>
          {canEdit && <Grid item xs={4}><StyledTermSheetButtonBlueSM onClick={handleSubmit}><StyledButtonCenteredSM>Save</StyledButtonCenteredSM></StyledTermSheetButtonBlueSM></Grid>}
          <Grid item xs={4}><StyledTermSheetButtonBlueTextSM onClick={handleReset}><StyledButtonCenteredSM>Reset Changes</StyledButtonCenteredSM></StyledTermSheetButtonBlueTextSM></Grid>
          <Grid item xs={4}><StyledLinkText onClick={() => { this.openCloseTermSheetPanel(null, values); }}>Hide Term Sheet</StyledLinkText></Grid>
          <Divider />
          <StyledScrollableGrid container item xs={12}>

            {FinancialsSection()}
            {AmortizationSection()}
            {PrepaymentSection()}
            {FinancialCovenantsSection()}
            {ExtensionsSection()}
            {ReserveAccountsSection()}
            {InterestRateProtectionSection()}
            {CashManagementSection()}
            {FeesSection()}
            {GuarantyTypeSection()}
            {OtherSection()}

          </StyledScrollableGrid>

        </StyledQuoteGrid>
      </Grid>
    </Frame>);
  }

  render() {
    return (
      <>
        <CardPageLayout {...this.props}
          leftComponent={this.renderLeft()}
          rightComponent={this.renderRight()}
        />
      </>
    );
  }
}

const mapStateToProps = ({ quoteDetail, authentication, loading }) => ({
  ...quoteDetail
  , guestPermission: mapGuestPermissions(authentication, quoteDetail.guestPermission)
  , company: mapCompanySelector(authentication)
  , authentication
  , isLoading: loading.loan_file_upload
  , comparableSeniorLoans: quoteDetail.quotesByPreference ? quoteDetail.quotesByPreference.comparable_senior_loans : {}
  , comparableMezzLoans: quoteDetail.quotesByPreference ? quoteDetail.quotesByPreference.comparable_mezz_loans : {}
  , comparableSupplementalLoans: quoteDetail.quotesByPreference ? quoteDetail.quotesByPreference.comparable_supplemental_loans : {}
});

export default compose(
  withRouter
  , withStyles(styles)
  , connect(mapStateToProps, {
    quoteDetailGetQuote
    , quoteDetailClearQuote
    , dealGet
    , getLoansByPreferenceAndLoanSeniority
    , getLoansByPreferenceAndLoanStatus
    , saveOrderChange
    , updateLoanDetails
    , saveQuoteShortListAndStatus
    , requestNewContact
    , deleteQuote
    , cloneQuote

    , loanGetNotes
    , loanPutNote
    , loanPostNote
    , loanDeleteNote
    , loanGetAttachments
    , loanPutAttachment
    , loanPostAttachment
    , loanDeleteAttachment
  })
)(QuoteDetail);
